// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"c8b8739d","20":"4aa7a4d4","39":"4b488e11","66":"6bedf2f7","150":"2e49af48","313":"6aabef0d","363":"a21fbcfd","407":"c9e6cef8","411":"9b1b0624","511":"9fb0cb5b","531":"927d3a3a","639":"e154ac10"}[chunkId] + ".chunk.js";
};